module.exports = __webpack_public_path__ + "static/media/fish.7521e712.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageSecAwarenrssSolution/fish.png
// module id = 621
// module chunks = 0